import React, { useState } from "react";
import Order from "./Order";

// Primary "Order Now" call to action: opens the modal listing our delivery and
// pickup apps.
const OrderButton = ({ className = "", label = "Order Now" }) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setModalOpen(true)}
        className={`btn btn-primary btn-xl btn-order text-uppercase ${className}`}
        aria-haspopup="dialog"
      >
        {label}
      </button>
      <Order modalOpen={modalOpen} handleClose={() => setModalOpen(false)} />
    </>
  );
};

export default OrderButton;
